export const getDatasourceById = async (component, id, include = {}) => {
  const config = {
    where: [
      {
        field: "id",
        op: "=",
        value: id,
        type: "AND"
      }
    ],
    include
  };

  const { data } = await component.$store.dispatch("REQUEST", {
    url: `permission_object?config=${JSON.stringify(config)}`
  });
  component.$store.commit("SET_DATASOURCE_FROM_TREE", {
    id,
    data: data[id]
  });

  return data[id];
};

export const getDatasourcesByDatatype = async (
  component,
  where = [],
  include = {}
) => {
  const config = {
    where,
    include
  };
  const { data } = await component.$store.dispatch("REQUEST", {
    url: `permission_object?config=${JSON.stringify(config)}`
  });
  const datasources = Object.values(data);

  datasources.forEach(data =>
    component.$store.commit("SET_DATASOURCE_FROM_TREE", {
      id: data.id,
      data
    })
  );

  return datasources || [];
};

export const getModelChildrenIds = children =>
  children.reduce((prev, ch) => {
    prev[ch.datatype] = ch.id;

    return prev;
  }, {});
